const $inject = ['$filter', 'moment', 'settingsService', 'travelService', 'cartService', 'ENUMS', 'dateTimeService'];

const flightFilterService = function flightFilterService(
  $filter,
  moment,
  settingsService,
  travelService,
  cartService,
  ENUMS,
  dateTimeService
) {
  const TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
  let showPanel = false;
  const service = {
    filters: new Filters(),
    getFilters: () => service.filters,
    isPanelOpen: () => showPanel,
    openPanel: openPanel,
    closePanel: closePanel,
    process: process,
    updateOptions: updateOptions,
    clear: clear,
    filterCheapestFares: filterCheapestFares,
    filtersApplied: 0,
  };

  service.filters = new Filters();
  updateOptions();

  function Filters() {
    let self = this;

    this.cartItems = {
      label: 'Cart',
      filterName: 'travelCartItemsFilter',
      cartItems: cartService.items,
      resultsIndex: 0,
      isActive: function () {
        return this.cartItems.length;
      },
    };

    this.stops = {
      label: 'Stops',
      id: 'stops',
      filterName: 'anyInArrayFilter',
      isResultsFilter: true,
      open: true,
      type: 'checkboxGroup',
      reference: 'Stops',
      options: [],
      selected: [],
      pkgCustomCount: (packages) => {
        const options = service.filters.stops.options;
        const counts = travelService.packageResults[0].Segments.map((segment, i) => {
          const count = {
            0: 0,
            1: 0,
            2: 0,
            all: 0,
          };
          for (const pkg of packages) {
            const stops = pkg.Segments[i].flight.Stops;
            count[stops]++;
          }
          return count;
        });

        travelService.packageResults[0].Segments.forEach((segment, i) => {
          options[i].forEach((opt) => {
            opt.count = counts[i][opt.value];
          });
        });
      },
      pkgSegmentFilter: pkgSegmentsOptionsFilter,
      clear: function () {
        this.options.forEach((opt) => opt.forEach((o) => (o.isActive = false)));
        this.selected = [];
      },
    };

    this.carrier = {
      label: 'Airlines',
      id: 'carrier',
      filterName: 'pkgCarrierFilter',
      isResultsFilter: true,
      open: true,
      type: 'checkboxGroup',
      maxOptions: 8,
      maxOptionsCur: 8,
      reference: 'Carrier',
      options: [],
      pkgCustomCount: (packages) => {
        const options = service.filters.carrier.options.map((optionSet) => optionSet.filter((o) => o.value !== 'all'));
        travelService.packageResults[0].Segments.forEach((segment, i) => {
          options[i].forEach((opt) => {
            packages.forEach((pkg) => {
              if (pkg.Segments[i].flight.Carrier === opt.value) opt.count++;
            });
          });
        });

        // set all preferred count
        service.filters.carrier.options.forEach((optionSet) => {
          const sumPreferredCounts = optionSet.reduce((sum, option) => (option.preferred ? sum + option.count : sum), 0);
          const allOption = optionSet.find((option) => option.value === 'all');
          if (allOption) allOption.count = sumPreferredCounts;
        });
      },
      pkgSegmentFilter: pkgSegmentsOptionsFilter,
      clear: function () {
        this.options.forEach((opt) => opt.forEach((o) => (o.isActive = false)));
        this.selected = [];
      },
    };

    this.flightTime = {
      label: 'Times',
      filterName: 'travelTimeFilter',
      isResultsFilter: true,
      open: true,
      type: 'departArrivalTime',
      defaultMax: 1439,
      defaultMin: 0,
      options: [],
      rzslider: {
        ceil: 1439,
        floor: 0,
        step: 5,
        noSwitching: true,
        interval: 1000,
        translate: translateMinutesTime,
        onChange: function () {
          process(self.flightTime);
        },
      },
      pkgSegmentFilter: function (packages, i) {
        const option = this.options[i];
        const ceil = this.rzslider.ceil;
        const { minArrive, maxArrive, minDepart, maxDepart } = option;
        const isActive = minArrive > 0 || maxArrive < ceil || minDepart > 0 || maxDepart < ceil;
        if (!isActive) return;
        if (isActive && this.isResultsFilter) bumpFiltersApplied(this, i);
        packages
          .filter((pkg) => pkg.visible)
          .forEach((pkg) => {
            const segment = pkg.Segments[i];
            if (!segment.visible) return;
            const flight = segment.flight;
            const departTime = dateTimeService.getMinutesFromTime(flight.DepartureTime);
            const arriveTime = dateTimeService.getMinutesFromTime(flight.ArrivalTime);
            segment.visible = departTime >= minDepart && departTime <= maxDepart && arriveTime >= minArrive && arriveTime <= maxArrive;
          });
      },
      isActive: function () {
        return this.min > this.defaultMin || this.max < this.defaultMax;
      },
      clear: function () {
        const ceil = this.rzslider.ceil;
        this.options.forEach((o) => {
          o.minArrive = 0;
          o.minDepart = 0;
          o.maxDepart = ceil;
          o.maxArrive = ceil;
        });
      },
    };

    this.priceRange = {
      label: 'Price',
      id: 'price',
      labelSuffix: `(${settingsService.settings.Currency.Code})`,
      filterName: 'travelPriceRangeFilter',
      isResultsFilter: true,
      open: true,
      type: 'range',
      reference: 'Price',
      options: [],
      rzslider: {
        id: 'price',
        floor: 0,
        noSwitching: true,
        interval: 1000,
        translate: (value) => $filter('currency')(value, '', 0),
        onChange: function () {
          process(this);
        },
      },
      pkgFareClassFilter: function (packages) {
        const option = this.options[0];
        const { min, max, defaultMin, defaultMax } = option;
        const isActive = min > defaultMin || max < defaultMax;
        if (!isActive) return;
        if (isActive && this.isResultsFilter) bumpFiltersApplied(this);
        packages
          .filter((pkg) => pkg.visible)
          .forEach((pkg) => {
            Object.values(pkg.FareClasses)
              .filter((fc) => fc && fc.visible)
              .forEach((fc) => {
                let cheapestFare = null;
                fc.Fares.filter((fare) => fare.visible).forEach((fare) => {
                  const fareInRange = fare.Amount >= min && fare.Amount <= max;
                  fare.visible = fareInRange;
                  if (fareInRange) {
                    if (!cheapestFare || fare.Amount < cheapestFare.Amount) cheapestFare = fare;
                  }
                });
                if (cheapestFare) fc.DisplayFare = cheapestFare;
                fc.visible = !!cheapestFare;
              });
          });
      },
      isActive: function () {
        return this.min > this.defaultMin || this.max < this.defaultMax;
      },
      clear: function () {
        this.options.forEach((o) => {
          o.min = o.defaultMin;
          o.max = o.defaultMax;
        });
      },
    };

    this.airports = {
      label: 'Connecting airports',
      id: 'airport',
      filterName: 'anyInArrayFilter',
      isResultsFilter: true,
      open: true,
      type: 'checkboxGroup',
      maxOptions: 8,
      maxOptionsCur: 8,
      options: [],
      selected: [],
      pkgCount: (segment, opt) => {
        segment.flight.Legs.forEach((leg) => {
          if (leg.Origin.Code === opt.value) opt.count++;
        });
      },
      pkgSegmentFilter: pkgSegmentsOptionsFilter,
      clear: function () {
        this.options.forEach((opt) => opt.forEach((o) => (o.isActive = false)));
        this.selected = [];
      },
    };

    this.layover = {
      label: 'Layover duration',
      id: 'layover',
      filterName: 'travelCarbonFootprintRangeFilter',
      isResultsFilter: true,
      open: false,
      type: 'range',
      reference: 'CarbonEmission',
      options: [],
      rzslider: {
        step: 5,
        noSwitching: true,
        interval: 1000,
        translate: (mins, sliderId, label) => {
          if (isNaN(mins) || mins === Infinity || mins === -Infinity) return self.layover.options[0].defaultMin + ' min';
          const days = Math.floor(mins / 1440);
          const hours = Math.floor((mins % 1440) / 60);
          const minutes = mins % 60;
          const pre = label === 'model' ? 'Min' : label === 'high' ? 'Max' : '';
          if (days === 0 && hours === 0) return `${pre} ${minutes} min`;
          if (days === 0) return `${pre} ${hours} hr ${minutes} min`;
          return `${pre} ${days} d ${hours} hr ${minutes} minutes`;
        },
        onChange: function () {
          process(self.layover);
        },
      },
      pkgSegmentFilter: function (packages, i) {
        const option = this.options[i];
        const { min, max, defaultMin, defaultMax } = option;
        const isActive = min > defaultMin || max < defaultMax;
        if (!isActive) return;
        bumpFiltersApplied(this, i);
        packages
          .filter((pkg) => pkg.visible)
          .forEach((pkg) => {
            const segment = pkg.Segments[i];
            if (!segment.visible) return;
            const layover = segment.flight.Details.filter((leg) => leg.Layover).map((leg) => leg.Layover);
            const layoverInMinutes = layover.map((time) => time.split(',').reduce((acc, val) => acc + parseInt(val), 0));
            segment.visible = layoverInMinutes.some((time) => time >= min && time <= max);
          });
      },
      clear: function () {
        this.options.forEach((o) => {
          o.min = o.defaultMin;
          o.max = o.defaultMax;
        });
      },
    };

    this.policy = {
      label: 'Policy',
      id: 'policy',
      filterName: 'anyInArrayFilter',
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      reference: 'Stops',
      options: [],
      pkgCustomCount: function (packages) {
        const counts = {
          in: 0,
          out: 0,
        };
        for (const pkg of packages) {
          const inPolicy = Object.values(pkg.FareClasses).some((fare) => fare && fare.Details.PolicyExceptionDetails.InPolicy);
          counts[inPolicy ? 'in' : 'out']++;
        }

        service.filters.policy.options.forEach((opt) => opt.forEach((o) => (o.count = counts[o.value])));
      },
      pkgFareClassFilter: pkgFareClassOptionsFilter,
      clear: function () {
        this.options.forEach((opt) => opt.forEach((o) => (o.isActive = false)));
        this.selected = [];
      },
    };

    this.cabin = {
      label: 'Cabin class',
      id: 'cabin',
      filterName: 'pkgCarrierFilter',
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      reference: 'Carrier',
      selectedReference: 'value',
      options: [],
      pkgCustomCount: function (packages) {
        this.options.forEach((opt) => opt.forEach((o) => (o.count = packages.filter((pkg) => pkg.FareClasses[o.label]).length)));
      },
      pkgFareClassFilter: pkgFareClassOptionsFilter,
      clear: function () {
        this.options.forEach((opt) => opt.forEach((o) => (o.isActive = false)));
        this.selected = [];
      },
    };

    this.carbonFootprintRange = {
      label: 'Carbon footprint',
      id: 'carbonFootprint',
      filterName: 'travelCarbonFootprintRangeFilter',
      isResultsFilter: true,
      open: false,
      type: 'range',
      reference: 'CarbonEmission',
      options: [],
      rzslider: {
        floor: 0,
        noSwitching: true,
        interval: 1000,
        translate: (value) => $filter('currency')(value, '', 0),
        onChange: function () {
          process(this);
        },
      },
      isActive: function () {
        return this.min > this.defaultMin || this.max < this.defaultMax;
      },
      pkgSegmentFilter: function (packages, i) {
        const option = this.options[i];
        const { min, max, defaultMin, defaultMax } = option;
        const isActive = min > defaultMin || max < defaultMax;
        if (!isActive) return;
        if (isActive && this.isResultsFilter) bumpFiltersApplied(this, i);
        packages
          .filter((pkg) => pkg.visible)
          .forEach((pkg) => {
            const segment = pkg.Segments[i];
            if (!segment.visible) return;
            const carbonValue = segment.flight.MinCarbonEmission;
            segment.visible = !!(carbonValue >= min && carbonValue <= max);
          });
      },
      clear: function () {
        this.options.forEach((o) => {
          o.min = o.defaultMin;
          o.max = o.defaultMax;
        });
      },
    };

    this.aircraft = {
      label: 'Aircraft Type',
      id: 'aircraft',
      filterName: 'pkgCarrierFilter',
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      filterbar: true,
      maxOptions: 8,
      maxOptionsCur: 8,
      reference: 'Carrier',
      selectedReference: 'value',
      options: [],
      pkgCount: (segment, opt) => {
        segment.flight.Details.forEach((leg) => {
          if (leg.EquipmentType === opt.value) opt.count++;
        });
      },
      pkgSegmentFilter: pkgSegmentsOptionsFilter,
      clear: function () {
        this.options.forEach((opt) => opt.forEach((o) => (o.isActive = false)));
      },
    };

    this.segment = {
      id: 'segment',
      pkgSegmentFilter: function (packages, i) {
        const values = [...new Set(packages.flatMap((pkg) => pkg.Segments.filter((s) => s.selected).map((s) => s.flight.Identifier)))];
        if (!values.length) return;
        bumpFiltersApplied(this, i);
        packages.forEach((pkg) => {
          if (!pkg.visible || pkg.Segments.find((s) => s.selected)) return;
          const segment = pkg.Segments[i];
          segment.selected = segment.visible = values.includes(segment.flight.Identifier);
        });
      },
      clear: function () {
        travelService.packageResults.forEach((pkg) => {
          pkg.Segments.forEach((segment) => (segment.selected = false));
        });
      },
    };
  }

  function bumpFiltersApplied(filter, i) {
    if (i && i > 0) return;
    service.filtersApplied++;
  }

  function createCarrierOptions(segment, i) {
    const options = service.filters.carrier.options;
    if (!options[i]) options[i] = [];
    const key = segment.flight.Carrier;
    const id = 'carrier-' + key;
    const option = options[i].find((opt) => opt.id === id);
    if (option) return;
    options[i].push({
      label: segment.flight.CarrierName,
      value: key,
      count: 0,
      id: id,
      preferred: segment.flight.Preferred,
    });
  }

  function createAircraftOptions(segment, i) {
    const options = service.filters.aircraft.options;
    if (!options[i]) options[i] = [];

    for (let leg of segment.flight.Details) {
      if (!leg.EquipmentType) continue;
      const key = leg.EquipmentType;
      const id = 'aircraft-' + key.replace(/[^a-zA-Z0-9]/g, '');
      const option = options[i].find((opt) => opt.id === id);
      if (option) continue;
      options[i].push({
        label: leg.EquipmentType,
        value: key,
        count: 0,
        id: id,
      });
      options[i].sort((a, b) => a.label.localeCompare(b.label));
    }
  }

  function createAirportsOptions(segment, i) {
    const options = service.filters.airports.options;
    if (!options[i]) options[i] = [];
    segment.flight.Legs.forEach((leg) => {
      const key = leg.Origin.Code;
      const id = 'airport-' + key;
      const option = options[i].find((opt) => opt.id === id);
      if (!option) {
        options[i].push({
          label: leg.Origin.City,
          value: key,
          count: 1,
          id: id,
        });
      }
    });
  }

  function createLayoverOptions(activeFltr) {
    if (activeFltr && activeFltr.id === 'layover') return;
    const filter = service.filters.layover;
    const options = filter.options;
    if (options.length) return;
    let layoverInMinutes = travelService.packageResults
      .filter((pkg) => pkg.visible)
      .flatMap((pkg) => pkg.Segments.flatMap((segment) => segment.flight.Details.filter((leg) => leg.Layover).map((leg) => leg.Layover)))
      .map((time) => time.split(',').reduce((acc, val) => acc + parseInt(val), 0));

    if (!layoverInMinutes.length) layoverInMinutes = [];
    const min = Math.min(...layoverInMinutes);
    const max = Math.max(...layoverInMinutes);
    filter.rzslider.floor = min;
    filter.rzslider.ceil = max;

    travelService.packageResults[0].Segments.forEach((segment, i) => {
      if (options[i]) return;
      options[i] = {
        min: min,
        max: max,
        defaultMin: min,
        defaultMax: max,
      };
    });
  }

  function addAllPreferredCarriers() {
    let options = service.filters.carrier.options;
    options.forEach((option, i) => {
      if (option.some((carrier) => carrier.value === 'all')) return;
      option.sort((a, b) => a.label.localeCompare(b.label));
      if (option.some((carrier) => carrier.preferred)) {
        let preferredCount = option.reduce((sum, carrier) => sum + (carrier.preferred ? carrier.count : 0), 0);
        option.unshift({
          label: 'All Preferred Airlines',
          value: 'all',
          id: `carrier-all-preferred-${i}`,
          preferred: true,
          count: preferredCount,
        });
      }
    });
  }

  function createStopOptions() {
    const options = service.filters.stops.options;
    travelService.packageResults[0].Segments.forEach((segment, i) => {
      if (options[i]) return;
      options[i] = [
        {
          label: 'Nonstop Only',
          value: 0,
          id: `stops-${i}-0`,
        },
        {
          label: '2 stops',
          value: 2,
          id: `stops-${i}-2`,
        },
        {
          label: '1 stop',
          value: 1,
          id: `stops-${i}-1`,
        },
        {
          label: '3 or more stops',
          value: 'all',
          id: `stops-${i}-all`,
        },
      ];
    });
  }

  function createPolicyOptions() {
    const options = service.filters.policy.options;
    const inPolicyFalse = travelService.packageResults.filter((pkg) =>
      Object.values(pkg.FareClasses).some((fare) => fare && !fare.Details.PolicyExceptionDetails.InPolicy)
    ).length;
    const inPolicyTrue = travelService.packageResults.length - inPolicyFalse;
    travelService.packageResults[0].Segments.forEach((segment, i) => {
      if (options[i]) return;
      options[i] = [
        {
          label: 'Out of policy',
          value: 'out',
          id: `policy-${i}-out`,
          count: inPolicyFalse,
        },
        {
          label: 'In policy',
          value: 'in',
          id: `policy-${i}-in`,
          count: inPolicyTrue,
        },
      ];
    });
  }

  function createPriceOptions() {
    const filter = service.filters.priceRange;
    const options = filter.options;
    let min = Number.MAX_VALUE;
    let max = 0;

    travelService.packageResults.forEach((pkg) => {
      Object.values(pkg.FareClasses).forEach((fare) => {
        if (!fare) return;
        const fareAmount = Math.round(fare.Details.Amount);
        if (fareAmount < min) min = fareAmount;
        if (fareAmount > max) max = fareAmount;
      });
    });

    filter.rzslider.floor = min;
    filter.rzslider.ceil = max;

    travelService.packageResults[0].Segments.forEach((segment, i) => {
      if (options[i]) return;
      options[i] = {
        min: min,
        max: max,
        defaultMin: min,
        defaultMax: max,
      };
    });
  }

  function createCabinOptions(segment, i) {
    const options = service.filters.cabin.options;
    travelService.packageResults[0].Segments.forEach((segment, i) => {
      if (!options[i]) options[i] = [];
      travelService.pkgFareClasses.forEach((fareClass) => {
        const key = fareClass.replace(/\s/g, '');
        const id = 'cabin-' + key;
        const option = options[i].find((opt) => opt.id === id);
        if (!option) {
          options[i].push({
            label: fareClass,
            value: key,
            count: 0,
            id: id,
          });
        }
      });
      options[i].sort((a, b) => a.label.localeCompare(b.label));
    });
  }

  function createCarbonOptions() {
    const filter = service.filters.carbonFootprintRange;
    const options = filter.options;
    const carbonEmissions = travelService.packageResults.flatMap((pkg) => pkg.Segments.map((s) => s.flight.MinCarbonEmission));
    const max = Math.max(...carbonEmissions);
    const min = Math.min(...carbonEmissions);

    filter.rzslider.floor = min;
    filter.rzslider.ceil = max;

    travelService.packageResults[0].Segments.forEach((segment, i) => {
      if (options[i]) return;
      options[i] = {
        min: min,
        max: max,
        defaultMin: min,
        defaultMax: max,
      };
    });
  }

  function createTimeOptions() {
    const options = service.filters.flightTime.options;
    travelService.packageResults[0].Segments.forEach((segment, i) => {
      if (options[i]) return;
      options[i] = {
        minDepart: 0,
        maxDepart: 1439,
        minArrive: 0,
        maxArrive: 1439,
      };
    });
  }

  function resetPackageVisibility() {
    travelService.packageResults.forEach((pkg) => {
      pkg.visible = true;
      Object.values(pkg.FareClasses)
        .filter((fare) => fare)
        .forEach((fc) => {
          fc.visible = true;
          fc.Fares.forEach((fare) => (fare.visible = true));
        });
      pkg.Segments.forEach((segment) => (segment.visible = true));
    });
  }

  function process(activeFltr) {
    resetPackageVisibility();
    let packages = travelService.packageResultsMaster;
    const filters = Object.values(service.filters);
    const segmentFilters = filters.filter((flt) => flt.pkgSegmentFilter);
    const fareClassesFilters = filters.filter((flt) => flt.pkgFareClassFilter);
    service.filtersApplied = 0;

    //segement filters (i.e. stops, carrier, airport, aircraft)
    packages[0].Segments.forEach((segment, i) => {
      segmentFilters.forEach((flt) => flt.pkgSegmentFilter(packages, i));
    });
    packages.forEach((pkg) => (pkg.visible = pkg.Segments.every((segment) => segment.visible)));

    // fareclass filters (i.e. cabin, policy, price)
    packages = packages.filter((pkg) => pkg.visible);
    fareClassesFilters.forEach((flt) => flt.pkgFareClassFilter(packages));
    packages.forEach((pkg) => {
      const fareClasses = Object.values(pkg.FareClasses).filter((fc) => fc);
      pkg.visible = fareClasses.some((fc) => fc.visible);
    });

    updateOptions(activeFltr);
  }

  function updateOptions(activeFltr) {
    const packages = travelService.packageResults;
    const filters = Object.values(service.filters);
    const activeFilterIndex = filters.findIndex((filter) => filter === activeFltr);

    createStopOptions();
    createTimeOptions();
    createPriceOptions();
    createCarbonOptions();
    createCabinOptions();
    createPolicyOptions();
    createLayoverOptions(activeFltr);

    for (let i = 0; i < packages.length; i++) {
      const pkg = packages[i];
      const segments = pkg.Segments;

      for (let j = 0; j < segments.length; j++) {
        const segment = segments[j];
        createCarrierOptions(segment, j);
        createAirportsOptions(segment, j);
        createAircraftOptions(segment, j);
      }
    }

    addAllPreferredCarriers();

    countFilteredOptions(activeFltr);

    if (activeFilterIndex !== -1) {
      filters.splice(activeFilterIndex, 1);
    }
  }

  function countFilteredOptions(activeFltr) {
    const packages = travelService.packageResults.filter((pkg) => pkg.visible);

    let filters = Object.values(service.filters);
    if (activeFltr) filters = filters.filter((f) => f !== activeFltr); //don't filter the passed in filter (the one that was toggled)

    clearFilteredCounts(filters);
    const countFunctions = filters.filter((f) => f.pkgCount);
    packages.forEach((pkg) => {
      pkg.Segments.forEach((segment, i) => {
        countFunctions.forEach((f) => f.options[i].forEach((o) => f.pkgCount(segment, o)));
      });
    });

    //find filters that have a pkgCustomCount function and call it
    filters.filter((f) => f.pkgCustomCount).forEach((f) => f.pkgCustomCount(packages));
  }

  function clearFilteredCounts(filters) {
    filters.forEach((flt) => {
      if (flt.options) flt.options.forEach((opt) => (Array.isArray(opt) ? opt.forEach((o) => (o.count = 0)) : (opt.count = 0)));
    });
  }

  function pkgSegmentsOptionsFilter(packages, i) {
    this.selected = this.selected || [];
    const values = this.selected[i] || [];
    if (!values.length) return;

    bumpFiltersApplied(this);
    packages.forEach((pkg) => {
      if (!pkg.visible) return;
      const segment = pkg.Segments[i];
      const flight = segment.flight;
      if (!segment.visible) return;
      switch (this.id) {
        case 'airport':
          segment.visible = flight.Legs.some((leg) => values.includes(leg.Origin.Code));
          break;
        case 'aircraft':
          segment.visible = flight.Details.some((leg) => values.includes(leg.EquipmentType));
          break;
        default:
          segment.visible = values.includes(flight[this.reference]);
      }
    });
  }
  pkgSegmentsOptionsFilter = memoize(pkgSegmentsOptionsFilter);

  function pkgFareClassOptionsFilter(packages) {
    this.selected = this.selected || [];
    const values = this.selected[0] || [];
    if (!values.length) return;

    bumpFiltersApplied(this);
    packages.forEach((pkg) => {
      if (!pkg.visible) return;
      const fareClasses = Object.entries(pkg.FareClasses).filter(([key, fc]) => fc && fc.visible);

      fareClasses.forEach(([key, fc]) => {
        switch (this.id) {
          case 'cabin':
            fc.visible = values.includes(key.replace(/\s/g, ''));
            break;
          case 'policy':
            values.forEach((val) => {
              const policy = fc.Details.PolicyExceptionDetails.InPolicy;
              fc.visible = val === 'in' ? policy : !policy;
            });
            break;
        }
      });
    });
  }
  pkgFareClassOptionsFilter = memoize(pkgFareClassOptionsFilter);

  function memoize(func) {
    const cache = new Map();
    return function (...args) {
      const key = JSON.stringify(args);
      if (cache.has(key)) return cache.get(key);
      const result = func.apply(this, args);
      cache.set(key, result);
      return result;
    };
  }

  function clear() {
    Object.values(service.filters).forEach((flt) => {
      if (typeof flt.clear === 'function') flt.clear();
    });
    process();
  }

  function openPanel() {
    showPanel = true;
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    showPanel = false;
    document.body.style.overflow = 'auto';
  }

  function translateMinutesTime(mins) {
    if (mins === 0) return '12:00 AM';
    let hours = Math.floor(mins / 60);
    let minutes = mins % 60;
    if (hours === 24 && minutes === 0) {
      hours = 23;
      minutes = 59;
    }
    if (minutes < 10) minutes = '0' + minutes;
    return moment(`${hours}:${minutes}`, 'H:mm').format(TIME_FORMAT);
  }

  function filterCheapestFares() {
    clear();
    const packages = travelService.packageResults;
    const distinctCarriers = new Set();
    packages.forEach((pkg) => pkg.Segments.forEach((segment) => distinctCarriers.add(segment.flight.Carrier)));
    const carriers = [...distinctCarriers];

    const cheapestFares = {};
    packages.forEach((pkg) => {
      pkg.visible = false;

      pkg.Segments.forEach((segment) => {
        const { Carrier } = segment.flight;
        if (carriers.includes(Carrier)) {
          Object.entries(pkg.FareClasses)
            .filter(([fareClassName, fareClass]) => fareClass)
            .forEach(([fareClassName, fareClass]) => {
              const { Amount } = fareClass.Details;
              if (!cheapestFares[Carrier] || Amount < cheapestFares[Carrier].Amount) {
                cheapestFares[Carrier] = { fareClassName, Amount };
                pkg.visible = true;
              }
            });
        }
      });
    });
  }

  return service;
};

flightFilterService.$inject = $inject;

export default flightFilterService;



// WEBPACK FOOTER //
// ./src/services/flightFilterService.js